/* eslint-disable react/jsx-one-expression-per-line */
import React from 'react';
import PropTypes from 'prop-types';

// atoms
import Text from '../../atoms/text';
import Button from '../../atoms/button';

// style
import './style.scss';

const ActivationOrganism = ({ submitTaste, loading }) => {
  return (
    <>
      <Text>
        Durante o período de teste, você terá acesso a todo o{' '}
        <strong>conteúdo de GZH de graça</strong> no computador, celular ou
        tablet. Os benefícios e descontos do Clube do Assinante também estarão
        disponíveis neste período.
      </Text>
      <div className="devices">
        <img src="../img/devices2.png" alt="Acesse de qualquer dispositivo" />
      </div>
      <Button onClick={() => submitTaste()} disabled={loading} action>
        {loading ? 'Ativando período de teste...' : 'Ativar período de teste'}
      </Button>
    </>
  );
};

ActivationOrganism.propTypes = {
  submitTaste: PropTypes.func.isRequired,
  loading: PropTypes.bool.isRequired
};

export default ActivationOrganism;
